// Click Through Source tracking key
export const GLOBAL_TRACKING_KEY = 'trackingThroughSourceKey';
